import http from 'hub-http/clients/apiClient';
export function fetchCallsV1SettingsUsage() {
  return http.get('calling-orchestration/v1/settings/usage/minutes').then(minutesUsage => {
    return {
      minutesUsage
    };
  });
}